<template>
  <div>
    <dig-login @OnLogIn="OnLogIn" v-if="!isLoggedIn" :isLoggingIn="isLoggingIn"></dig-login>
    <dig-nav @OnLogOut="OnLogOut" v-if="isLoggedIn" :profile="profile" :items=nav :selectedNav.sync="selectedNav">
      <dig-cashflow v-if="selectedNav==0"></dig-cashflow>
      <dig-reimbursement v-if="selectedNav==1"></dig-reimbursement>
      <dig-payment v-if="selectedNav==2"></dig-payment>
      <dig-prive v-if="selectedNav==3"></dig-prive>
    </dig-nav>
  </div>
</template>

<script>
require('./digilib_web/core/digitify.css')
require('./internal.css')
import Nav from './digilib_web/vue/navbar.vue'
import Login from './components/login.vue'
import Cashflow from './components/cashflow.vue'
import Reimbursement from './components/reimbursement.vue'
import Payment from './components/payment.vue'
import Prive from './components/prive.vue'
import { Http } from './digilib_web/core/digitify.js'

export default {
  name: 'app',
  components: {
    'dig-nav': Nav,
    'dig-login': Login,
    'dig-cashflow': Cashflow,
    'dig-reimbursement': Reimbursement,
    'dig-payment': Payment,
    'dig-prive': Prive,
  },
  data() {
		return {
      nav:[
        {title:'Cashflow', icon:'fa fa-balance-scale'},
        {title:'Reimbursement', icon:'fa fa-mail-forward'},
        {title:'Payment', icon:'fa fa-money'},
        {title:'Prive', icon:'fa fa-handshake-o'},
      ],
      selectedNav: 0,
      isLoggingIn: false,
      isLoggedIn: false,
      profile: {},
		}
  },
  methods: {
    OnLogIn: function(val) {
      if (this.isLoggingIn) { return; }
      this.isLoggingIn = true;
      Http.Request(
      'POST', 'login',
      {
        data: val,
        OnResponse:function(json) {
          this.isLoggingIn = false;
          if (json.success) {
            localStorage.setItem('token', json.token);
            this.isLoggedIn = true;
            this.GetProfile();
          } else {
            alert(json.msg);
          }
        }.bind(this)
      });
    },
    OnLogOut: function() {
      localStorage.removeItem('token');
      this.isLoggedIn = false;
    },
    GetProfile: function() {
      if (this.isLoggedIn) {
        Http.Request(
          'GET', 'profile',
          {
            OnResponse:function(json) {
              this.profile = json;
            }.bind(this)
          }
        );
      }
    }
  },
  mounted() {
    var token = localStorage.getItem('token');
    if (token != null) {
      this.isLoggedIn = true;
      this.GetProfile();
    }
  }
}
</script>
